import { useCombinedQueriesTeamGeneralInfo } from '@heidi/workspace/data';
import { useAtomValue } from 'jotai';

import {
  getForcedTeamRoleDevOverride,
  upgradeNudgesDevOverrideAtom,
} from '../../../data/billing-dev/upgrade-nudges-overrides';

export type UsageNudgeTeamRole = {
  hasTeam: boolean;
  /** `undefined` while the team role is still loading. */
  isTeamAdmin: boolean | undefined;
  /** Dev tools forced the role; a forced role also counts as being on a team. */
  isRoleForced: boolean;
};

/** The team role the upgrade nudge is judged by, with the dev-tools role override applied. */
export function useUsageNudgeTeamRole(): UsageNudgeTeamRole {
  const { hasTeam, isTeamAdmin } = useCombinedQueriesTeamGeneralInfo();
  const forcedRole = getForcedTeamRoleDevOverride(
    useAtomValue(upgradeNudgesDevOverrideAtom)
  );
  if (forcedRole == null) {
    return { hasTeam: !!hasTeam, isTeamAdmin, isRoleForced: false };
  }
  return { hasTeam: true, isTeamAdmin: forcedRole === 'admin', isRoleForced: true };
}
